import { FileText, FolderKanban, Layers, Library, Users, type LucideIcon } from 'lucide-react';

/** One admin section. Shared by the admin home cards and the console tab bar so
 *  the two never drift. `labelKey`/`subKey` are i18n keys (title + one-liner). */
export interface AdminSection {
  readonly to: string;
  readonly labelKey: string;
  readonly subKey: string;
  readonly Icon: LucideIcon;
}

/** The five admin console sections, in nav order. */
export const ADMIN_SECTIONS: readonly AdminSection[] = [
  { to: '/admin/users', labelKey: 'admin.users', subKey: 'admin.subUsers', Icon: Users },
  { to: '/admin/domains', labelKey: 'admin.domains', subKey: 'admin.subDomains', Icon: Layers },
  { to: '/admin/projects', labelKey: 'admin.allProjects', subKey: 'admin.subAllProjects', Icon: FolderKanban },
  { to: '/admin/summaries', labelKey: 'admin.reviewSummaries', subKey: 'admin.subSummaries', Icon: FileText },
  { to: '/admin/capabilities', labelKey: 'admin.capabilities', subKey: 'admin.subCapabilities', Icon: Library },
];
